module.exports = __webpack_public_path__ + "static/media/drag-bg.7d160d42.svg";